<template>
    <!-- 按钮组件 -->
    <el-button
    :size="size"
    :type="type"
    :plain="plain"
    :round="round"
    :circle="circle"
    :loading="loading"
    :disabled="disabled"
    :icon="icon"
    :autofocus="autofocus"
    :native-type="nativeType"
    :btnText="btnText"
    @click.native="btnClick"
    >
    {{btnText}}
    </el-button>
</template>
<script>
export default {
    name:"VelBtn",
    props:{
        size:String,
        type:{
            type: String,
            default:'primary'
        },
        isPlain:Boolean,
        isRound:Boolean,
        isCircle:Boolean,
        loading:Boolean,
        isDisable:Boolean,
        icon:String,
        isAutofocus:Boolean,
        nativeType:String,
        btnText:{
            type: String,
            default: 'button'
        }
    },
    data() {
        return {
            plain:false,
            round:false,
            circle:false,
            disabled:false,
            autofocus:false,
        };
    },
    created(){
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isPlain ? this.plain = true : this.plain
            this.isRound ? this.round = true : this.round
            this.isCircle ? this.circle = true : this.circle
            this.isDisable ? this.disabled = true : this.disabled
            this.isAutofocus ? this.autofocus = true : this.autofocus
        },
        btnClick(e){
            this.$emit('btnClick',e)
        }
    },
}
</script>